import React from "react";
import { FaTooth } from "react-icons/fa";

const DentesAdultoMemo = ({
  selectedDentesAdulto,
  selectedDentesInfantil,
  onDenteClick,
  onCondicaoChange,
  historicoVisual,
  condicoesVisualHistorico,
  condicoesDentes,
  dentesProcessados,
}) => {
  const getDenteSituacao = (denteNumber) => {
    // 1. Verifica selecionados atuais (prioridade máxima)
    const denteAdulto = selectedDentesAdulto?.find(
      (d) => d && d.numero === denteNumber
    );
    if (denteAdulto) return denteAdulto.situacao === 1 ? 3 : 4;

    const denteInfantil = selectedDentesInfantil?.find(
      (d) => d && d.numero === denteNumber
    );
    if (denteInfantil) return denteInfantil.situacao === 1 ? 3 : 4;

    // 2. Verifica processados (do atendimento atual)
    const denteProcessado = dentesProcessados?.find(
      (d) => d.numero === denteNumber
    );
    if (denteProcessado) {
      return denteProcessado.situacao === 1 ? 3 : 4;
    }

    // 3. Mostrar histórico visual
    if (historicoVisual && historicoVisual[denteNumber]) {
      const situacao = parseInt(historicoVisual[denteNumber]) || 0;
      return situacao;
    }

    return 0;
  };

  const getCondicaoExibir = (numeroDente) => {
    if (condicoesDentes && condicoesDentes[numeroDente]) {
      return condicoesDentes[numeroDente];
    }
    if (condicoesVisualHistorico && condicoesVisualHistorico[numeroDente]) {
      return condicoesVisualHistorico[numeroDente];
    }
    return "";
  };

  const getCorPorSituacao = (situacao) => {
    switch (situacao) {
      case 1:
        return { backgroundColor: "#c62828", color: "#c62828", borderColor: "#c62828" };
      case 2:
        return { backgroundColor: "#1976d2", color: "#1976d2", borderColor: "#1976d2" };
      case 3:
        return { backgroundColor: "#f44336", color: "white", borderColor: "#f44336" };
      case 4:
        return { backgroundColor: "#2196F3", color: "white", borderColor: "#2196F3" };
      default:
        return { backgroundColor: "", color: "", borderColor: "" };
    }
  };

  const DenteIndividual = ({ numeroExibido }) => {
    const faces = [
      { number: `Dente ${numeroExibido} - M`, label: "M", position: "top" },
      { number: `Dente ${numeroExibido} - V`, label: "V", position: "right" },
      { number: `Dente ${numeroExibido} - O`, label: "O", position: "bottom" },
      { number: `Dente ${numeroExibido} - D`, label: "D", position: "left" },
      { number: `Dente ${numeroExibido} - L`, label: "L", position: "center" },
    ];

    const condicaoAtual = getCondicaoExibir(numeroExibido);

    const handleCondicaoClick = () => {
      if (onCondicaoChange) {
        onCondicaoChange(numeroExibido, null);
      }
    };

    const handleDenteClickWrapper = (faceNumber) => {
      if (onDenteClick) {
        onDenteClick(faceNumber);
      }
    };

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: "0 -5px",
        }}
      >
        {/* Condição em cima */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <input
            type="text"
            value={condicaoAtual}
            onClick={handleCondicaoClick}
            readOnly
            style={{
              width: "35px",
              padding: "4px 6px",
              fontSize: "12px",
              fontWeight: "bold",
              textAlign: "center",
              border: condicaoAtual ? "1px solid #B83732" : "1px solid #ddd",
              borderRadius: "4px",
              outline: "none",
              transition: "all 0.2s",
              cursor: "pointer",
              backgroundColor: condicaoAtual ? "#fff0f0" : "white",
              color: condicaoAtual ? "#B83732" : "#666",
            }}
            placeholder="?"
            title={
              condicaoAtual
                ? `Condição atual: ${condicaoAtual}. Clique para alterar`
                : "Clique para selecionar uma condição"
            }
          />
        </div>

        {/* Container dos botões do dente */}
        <div className="dente-container">
          {faces.map((face) => {
            const situacao = getDenteSituacao(face.number);
            const cores = getCorPorSituacao(situacao);
            const temCor = cores.backgroundColor !== "";
            const isHistorico = situacao === 1 || situacao === 2;

            if (face.position === "center") {
              return (
                <button
                  key={face.number}
                  onClick={() => !isHistorico && handleDenteClickWrapper(face.number)}
                  className="botao-central"
                  style={temCor ? cores : {}}
                  disabled={isHistorico}
                  title={
                    situacao === 1
                      ? "Pendente (Histórico - não clicável)"
                      : situacao === 2
                      ? "Concluído (Histórico - não clicável)"
                      : situacao === 3
                      ? "Pendente (Atual - clique para finalizar)"
                      : situacao === 4
                      ? "Concluído (Atual - clique para remover)"
                      : ""
                  }
                >
                  {face.label}
                </button>
              );
            }

            return (
              <button
                key={face.number}
                onClick={() => !isHistorico && handleDenteClickWrapper(face.number)}
                className={`botao-dente ${face.position}`}
                style={temCor ? cores : {}}
                disabled={isHistorico}
                title={
                  situacao === 1
                    ? "Pendente (Histórico - não clicável)"
                    : situacao === 2
                    ? "Concluído (Histórico - não clicável)"
                    : situacao === 3
                    ? "Pendente (Atual - clique para finalizar)"
                    : situacao === 4
                    ? "Concluído (Atual - clique para remover)"
                    : ""
                }
              >
                {face.label}
              </button>
            );
          })}
        </div>

        {/* Número do dente em baixo */}
        <div
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            color: "#2c3e50",
          }}
        >
          {numeroExibido}
        </div>
      </div>
    );
  };

  const numerosExibicaoSuperior = [
    18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28,
  ];
  const numerosExibicaoInferior = [
    48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38,
  ];

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "nowrap",
          marginBottom: "35px",
        }}
      >
        {numerosExibicaoSuperior.map((numExibido, index) => (
          <React.Fragment key={`sup-${index}`}>
            <DenteIndividual numeroExibido={numExibido} />
            {index === 7 && <div style={{ width: "20px" }} />}
          </React.Fragment>
        ))}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "nowrap",
        }}
      >
        {numerosExibicaoInferior.map((numExibido, index) => (
          <React.Fragment key={`inf-${index}`}>
            <DenteIndividual numeroExibido={numExibido} />
            {index === 7 && <div style={{ width: "20px" }} />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default DentesAdultoMemo;